import React, { useContext } from "react";
import { t } from "i18next";
import { Table } from "antd";

import { ModalsContext } from "../../../../../../../context/modals.context";
import { Modal } from "../../../../../../../components/Modal/Modal";
import { IOvlascenaLicaZaPreuzimanjeMarkicaEncodedProps } from "../../../../../../../modules/obligee/exciseStamps/exciseStamps.types";

interface IAuthorizedPersonsModalProps {
  tableData: IOvlascenaLicaZaPreuzimanjeMarkicaEncodedProps[];
}

export const AuthorizedPersonsModal: React.FC<IAuthorizedPersonsModalProps> = ({
  tableData,
}) => {
  const { isModalVisible, clearModals } = useContext(ModalsContext);
  const handleCancel = () => {
    clearModals();
  };

  const colDef = [
    { title: t("TABLES.IME_I_PREZIME"), dataIndex: "imeIPrezime" },
    { title: t("TABLES.BROJ_LICNE_KARTE"), dataIndex: "encodedBrlk" },
  ];

  return (
    <Modal
      name="ovlascena-lica-za-preuzimanje-modal"
      title={t("AKCIZNE_MARKICE.OVLASCENA_LICA_ZA_PREUZIMANJE_MARKICA")}
      footer={null}
      onCancel={handleCancel}
      open={isModalVisible("authorizedPersons")}
    >
      <Table columns={colDef} dataSource={tableData} />
    </Modal>
  );
};
